
export default function Privacy() {
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
            <header>
                <p className="eyebrow">Legal</p>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-2 leading-tight">
                    Privacy Policy
                </h1>
                <p className="text-sm text-[var(--lt-muted)] mt-3">
                    Effective date: February 1, 2026
                </p>
            </header>

            <section className="mt-10 space-y-6 text-[var(--lt-text)] leading-relaxed">
                <p>
                    This Privacy Policy describes how <strong>LipiTyping</strong>{" "}
                    (“we”, “our”, or “us”) collects, uses, and protects information
                    when you use our web application at{" "}
                    <em>lipityping.com</em>. By using LipiTyping, you agree to the
                    practices described here.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    1. Information we collect
                </h2>
                <p>
                    When you create an account we store the name and email address
                    you provide, together with a hashed version of your password.
                    We also record your typing results (words per minute, accuracy,
                    duration, language, and mode) so that your progress, streak,
                    and leaderboard position can be calculated.
                </p>
                <p>
                    We do not collect payment information. We do not sell, rent, or
                    trade your personal information.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    2. How we use information
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-[var(--lt-muted)]">
                    <li>To authenticate your account and keep it secure.</li>
                    <li>
                        To calculate personal statistics, streaks, and the shared
                        leaderboard.
                    </li>
                    <li>To improve LipiTyping's lessons, tests, and utility widgets.</li>
                    <li>
                        To respond to messages you send us through the contact form.
                    </li>
                </ul>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    3. Local storage, analytics and advertising
                </h2>
                <p>
                    When you log in, LipiTyping stores a sign-in token in your
                    browser's local storage so you stay signed in. It is removed
                    when you log out, and you can clear it at any time from your
                    browser settings. LipiTyping does not set its own tracking
                    cookies.
                </p>
                <p>
                    LipiTyping does not currently use third-party analytics
                    services. Our servers keep standard technical logs, such as
                    request times and errors, to keep the service running and
                    secure.
                </p>
                <p>
                    LipiTyping may use Google AdSense or cookie tracking to deliver
                    tailored advertisements. If advertising is enabled, third-party
                    vendors, including Google, may use cookies to serve ads based on
                    your visits to this and other websites.
                </p>
                <p>
                    You may opt out of personalised advertising at any time by
                    visiting{" "}
                    <a
                        href="https://www.google.com/settings/ads"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[var(--lt-terracotta)] hover:underline"
                    >
                        Google Ads Settings
                    </a>{" "}
                    or, for other third-party networks,{" "}
                    <a
                        href="https://www.aboutads.info/choices/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[var(--lt-terracotta)] hover:underline"
                    >
                        www.aboutads.info/choices
                    </a>
                    .
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    4. Third-party services
                </h2>
                <p>
                    We rely on public APIs published by Nepal Rastra Bank, the
                    Federation of Nepal Gold and Silver Dealers Association, and
                    Open-Meteo to display forex, bullion, and weather information.
                    No personal data is sent to those services on your behalf.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    5. Data storage &amp; security
                </h2>
                <p>
                    Account data is stored in a managed MongoDB database.
                    Passwords are hashed using bcrypt before storage. Access to
                    production data is restricted to authorised operators.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    6. Your rights
                </h2>
                <p>
                    You can request a copy or deletion of your account data at any
                    time by emailing{" "}
                    <a
                        href="mailto:hello@lipityping.com"
                        className="text-[var(--lt-terracotta)] hover:underline"
                    >
                        hello@lipityping.com
                    </a>
                    . We will respond within a reasonable time frame.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    7. Changes to this policy
                </h2>
                <p>
                    We may update this Privacy Policy from time to time. Changes
                    will be reflected here with an updated effective date. Material
                    changes will be highlighted on our home page.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-8">
                    8. Contact
                </h2>
                <p>
                    Questions or concerns? Please email{" "}
                    <a
                        href="mailto:hello@lipityping.com"
                        className="text-[var(--lt-terracotta)] hover:underline"
                    >
                        hello@lipityping.com
                    </a>{" "}
                    or use the{" "}
                    <a
                        href="/contact"
                        className="text-[var(--lt-terracotta)] hover:underline"
                    >
                        contact page
                    </a>
                    .
                </p>
            </section>
        </div>
    );
}
